import React from 'react';
import PropTypes from 'prop-types';
import { head } from 'lodash';
import { Button, Cushion, Grid, Space, Typography } from '@pitchero/react-ui';
import { Trans } from '../../lib/i18n';

const TeamFilter = ({ onChange, sections, selected, ...otherProps }) => {
  const listStyle = {
    listStylePosition: 'outside',
    listStyleType: 'none',
    margin: 0,
    padding: 0,
  };

  const clearSelectionButton = () => {
    if (!selected) {
      return null;
    }
    return (
      <Cushion vertical="small" component="div">
        <Button
          onClick={() => onChange(null)}
          tabIndex={0}
          theme="text"
          type="button"
          {...otherProps}
        >
          <Typography preset="subtitle--small" color="dustygrey">
            <Trans i18nKey="news:clear_team_filter">Clear</Trans>
          </Typography>
        </Button>
      </Cushion>
    );
  };

  const renderSectionTeams = (section) =>
    section.teams.map((team) => (
      <Typography key={team.id} color="primary">
        <li style={{ listStyleType: selected === team.id ? 'disc' : 'none' }}>
          <Cushion vertical="small" component="div">
            <Button
              onClick={() => onChange(team.id)}
              tabIndex={0}
              {...otherProps}
              theme="text"
              type="button"
            >
              <Typography preset="subtitle--small" color="dustygrey">
                {team.name}
              </Typography>
            </Button>
          </Cushion>
        </li>
      </Typography>
    ));

  const renderSections = () => {
    if (sections.length === 1) {
      return (
        <>
          {selected && <li>{clearSelectionButton()}</li>}
          {renderSectionTeams(head(sections))}
        </>
      );
    }

    return sections.map((section) => (
      <Space bottom="large" key={section.id}>
        <li>
          <Space bottom="small">
            <Typography preset="tag--large" component="div" color="primary">
              {section.name}
            </Typography>
          </Space>
          <ol style={listStyle}>{renderSectionTeams(section)}</ol>
        </li>
      </Space>
    ));
  };

  const gridProps = {
    columns: 'repeat(auto-fill, minmax(240px, 1fr))',
    rowGap: sections.length === 1 ? 0 : 48,
    columnGap: sections.length === 1 ? 0 : 48,
    responsive: [
      {
        maxWidth: 720,
        props: { display: 'block' },
      },
    ],
  };

  return (
    <>
      {sections.length > 1 && selected && (
        <Grid {...gridProps}>
          <Space bottom="medium">{clearSelectionButton()}</Space>
        </Grid>
      )}
      <Grid component="ol" {...gridProps} className="ie-grid-four-col" style={listStyle}>
        {renderSections()}
      </Grid>
    </>
  );
};
TeamFilter.defaultProps = {
  selected: null,
};

TeamFilter.propTypes = {
  onChange: PropTypes.func.isRequired,
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      teams: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number,
          name: PropTypes.string,
        }),
      ),
    }),
  ).isRequired,
  selected: PropTypes.number,
};

export default TeamFilter;
